import request from '@/utils/request'
// 提交idfa 和通讯录
function addressBook () {
  const contant = getContactsFromStorage()
  const idfa = localStorage.getItem('idfa') || ''
  if (contant || idfa) {
    const contantList = JSON.stringify(contant) || JSON.stringify([])
    request.post('addressBook', { contantList, idfa: idfa.replace(/"/g, '') })
  }
}

// 判断是否使用最新的相机逻辑  只需要在此处添加需要兼容的apitype
export function isUseLatestLogic () {
  const LATEST_CAMERA_API_TYPES = ['2', '3', '4', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19']
  const type = sessionStorage.getItem('apitype')
  return LATEST_CAMERA_API_TYPES.includes(type)
}

// 兼容多种通讯录储存到localStorage的key
export function getContactsFromStorage () {
  const keyList = [
    {
      contactKey: 'contact',
      name: 'accountName',
      phone: 'accountPhone'
    },
    {
      contactKey: 'hfdrs',
      name: 'rwer',
      phone: 'weer'
    },
    {
      contactKey: 'weweree',
      name: 'werwe',
      phone: 'werer'
    },
    {
      contactKey: 'sdfw',
      name: 'wedrr',
      phone: 'werst'
    },
    {
      contactKey: 'fggghz',
      name: 'wwere',
      phone: 'fsdsf'
    },
    {
      contactKey: 'sqeqa',
      name: 'sdw',
      phone: 'fgf'
    },
    {
      contactKey: 'yteere',
      name: 'wer',
      phone: 'qws'
    },
    {
      contactKey: 'vders',
      name: 'sadd',
      phone: 'fees'
    },
    {
      contactKey: 'wethe',
      name: 'sdwes',
      phone: 'fgews'
    },
    {
      contactKey: 'wovji',
      name: 'mhf',
      phone: 'qivfd'
    },
    {
      contactKey: 'sdwew',
      name: 'sews',
      phone: 'wegs'
    },
    {
      contactKey: 'fswef',
      name: 'weer',
      phone: 'dsww'
    },
    {
      contactKey: 'lshjkf',
      name: 'fjahgd',
      phone: 'cbhduw'
    },
    {
      contactKey: 'rwersdfs',
      name: 'fwesd',
      phone: 'vcdf'
    },
    {
      contactKey: 'yuityuthg',
      name: 'dgerh',
      phone: 'jtuyjkt'
    },
    {
      contactKey: 'rutyrgdf',
      name: 'egdfhr',
      phone: 'dfgerw'
    },
    {
      contactKey: 'fdgseryhd',
      name: 'sdfsdfwe',
      phone: 'dfgerg'
    }

  ]
  let contant = ''
  // 使用some方法，当找到有值的key时会自动终止循环
  keyList.some(key => {
    const valueJSON = localStorage.getItem(key.contactKey)
    if (valueJSON) {
      const valueArray = JSON.parse(valueJSON)
      contant = valueArray.map(item => ({
        accountName: item[key.name],
        accountPhone: item[key.phone]
      }))
      return true
    }
    return false
  })
  return contant
}
export default addressBook
